<spe-alert [class]="apiStatus" [message]="message"></spe-alert>
<div class="row">
  <div class="col-lg-6">
    <form [formGroup]="mainFormGroup" #formDirective="ngForm">
      <!-- senha atual -->
      <spe-titulo-sessao titulo="Senha atual" icone="/assets/icones/cinza/cadeado-aberto.svg"> </spe-titulo-sessao>

      <mat-form-field
        *ngIf="flag != 'true'"
        [ngClass]="commonService.switchMatErrorClassResponsivity(mainFormGroup.controls.oldPassword)"
        class="mb-0"
      >
        <mat-label>Senha</mat-label>
        <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="oldPassword" />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="hidePassword = !hidePassword"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hidePassword"
        >
          <mat-icon *ngIf="!hidePassword" svgIcon="olho-aberto-current" class="color-brand-principal"></mat-icon>
          <mat-icon *ngIf="hidePassword" svgIcon="olho-fechado-current" class="color-brand-principal"></mat-icon>
        </button>
        <mat-error>{{ validatorErrors(mainFormGroup.controls.oldPassword) }}</mat-error>
      </mat-form-field>

      <!-- nova senha -->
      <spe-titulo-sessao titulo="Nova senha" icone="/assets/icones/cinza/cadeado.svg"> </spe-titulo-sessao>

      <mat-form-field
        class="mb-16"
        [ngClass]="commonService.switchMatErrorClassResponsivity(mainFormGroup.controls.password)"
      >
        <mat-label>Senha</mat-label>
        <input matInput matInput [type]="hideNewPassword ? 'password' : 'text'" formControlName="password" />
        <button mat-icon-button matSuffix (click)="hideNewPassword = !hideNewPassword">
          <mat-icon *ngIf="!hideNewPassword" svgIcon="olho-aberto-current" class="color-brand-principal"></mat-icon>
          <mat-icon *ngIf="hideNewPassword" svgIcon="olho-fechado-current" class="color-brand-principal"></mat-icon>
        </button>
        <mat-error>{{ validatorErrors(mainFormGroup.controls.password) }}</mat-error>
      </mat-form-field>

      <!-- regras de senha -->
      <div *ngIf="!passwordTouched">
        <div class="d-flex gap-2 align-items-center">
          <mat-icon class="icon">circle</mat-icon>
          <small>Mínimo 8 caracteres</small>
        </div>
        <div class="d-flex gap-2 align-items-center">
          <mat-icon class="icon">circle</mat-icon>
          <small>Mínimo 1 caractere minúsculo</small>
        </div>
        <div class="d-flex gap-2 align-items-center">
          <mat-icon class="icon">circle</mat-icon>
          <small>Mínimo 1 caractere maiúsculo</small>
        </div>
        <div class="d-flex gap-2 align-items-center">
          <mat-icon class="icon">circle</mat-icon>
          <small>Mínimo 1 caractere numérico</small>
        </div>
        <div class="d-flex gap-2 align-items-center">
          <mat-icon class="icon">circle</mat-icon>
          <small>{{ 'Mínimo 1 caractere especial !@#$()&*' }}</small>
        </div>
      </div>

      <div *ngIf="passwordTouched">
        <div class="d-flex gap-2 align-items-center">
          <mat-icon class="icon icon-check" *ngIf="rule1">done</mat-icon>
          <mat-icon class="icon icon-error" *ngIf="!rule1">close</mat-icon>
          <small>Mínimo 8 caracteres</small>
        </div>
        <div class="d-flex gap-2 align-items-center">
          <mat-icon class="icon icon-check" *ngIf="rule4">done</mat-icon>
          <mat-icon class="icon icon-error" *ngIf="!rule4">close</mat-icon>
          <small>Mínimo 1 caractere minúsculo</small>
        </div>
        <div class="d-flex gap-2 align-items-center">
          <mat-icon class="icon icon-check" *ngIf="rule3">done</mat-icon>
          <mat-icon class="icon icon-error" *ngIf="!rule3">close</mat-icon>
          <small>Mínimo 1 caractere maiúsculo</small>
        </div>
        <div class="d-flex gap-2 align-items-center">
          <mat-icon class="icon icon-check" *ngIf="rule5">done</mat-icon>
          <mat-icon class="icon icon-error" *ngIf="!rule5">close</mat-icon>
          <small>Mínimo 1 caractere numérico</small>
        </div>
        <div class="d-flex gap-2 align-items-center">
          <mat-icon class="icon icon-check" *ngIf="rule2">done</mat-icon>
          <mat-icon class="icon icon-error" *ngIf="!rule2">close</mat-icon>
          <small>{{ 'Mínimo 1 caractere especial !@#$()&*' }}</small>
        </div>
      </div>
      <br />

      <mat-form-field [ngClass]="commonService.switchMatErrorClassResponsivity(mainFormGroup.controls.passwordConfirm)">
        <mat-label>Repetir senha</mat-label>
        <input matInput [type]="hideRepeatNewPassword ? 'password' : 'text'" formControlName="passwordConfirm" />
        <button
          mat-icon-button
          matSuffix
          (click)="hideRepeatNewPassword = !hideRepeatNewPassword"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hideRepeatNewPassword"
        >
          <mat-icon
            *ngIf="!hideRepeatNewPassword"
            svgIcon="olho-aberto-current"
            class="color-brand-principal"
          ></mat-icon>
          <mat-icon
            *ngIf="hideRepeatNewPassword"
            svgIcon="olho-fechado-current"
            class="color-brand-principal"
          ></mat-icon>
        </button>
        <mat-error>
          {{ validatorErrors(mainFormGroup.controls.passwordConfirm) }}
        </mat-error>
      </mat-form-field>
    </form>

    <div class="text-end">
      <button
        mat-flat-button
        (click)="submitButton(formDirective)"
        [ngClass]="{ caixaButton: sigla == 'CAIXA' }"
        [disabled]="!mainFormGroup.valid"
      >
        Alterar senha
      </button>
    </div>
  </div>
</div>
